import React, { Component, Fragment } from 'react'

import moment from 'moment'
import {
  DatePicker,
  Layout,
  Breadcrumb,
  Form,
  Input,
  Divider,
  Row,
  Col,
  Avatar,
  Select,
  Switch,
  Tag,
  Icon,
  Button,
  Checkbox,
  message,
  notification,
  Skeleton,
  Popover,
  Radio,
  Tabs,
  InputNumber,
  List,
  Card,
  Spin,
  Modal,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons'
// import styles from './styles.module.scss';
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import ValidatorErrorAlert from '../../components/ValidatorErrorAlert/ValidatorErrorAlert'
import CitySelect from 'components/CitySelect/CitySelect'
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose'
import bannerImage from 'assets/img/banner/banner-catalog.png'
import { store } from '../../reducers'
import { updateAuthInfo } from '../../reducers/auth'
import { UploadOutlined } from '@ant-design/icons'
import WUpload from 'components/WUpload/WUpload'
import { __ } from '@wordpress/i18n'

const Local = _.get(window, 'VC_CONFIG.Locale')
const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
const { TabPane } = Tabs
const VC_CONFIG = _.get(window, 'VC_CONFIG')

// 前端頁面
export default class UserProfileOca extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
    isSubmitData: false,
    memberVip: '',
    memberLinkcode: '',
    bonusPoint: 0,
    bonusPointDiscount: 0,
    isLoading: true,
  }

  componentDidMount() {
    this.LoadOCA()
    AppHelper.updateConfig()
    this.getMemberProfile()
    this.getProfile()
    //this.setState({ isFetchData: true},() => {this.reloadTab()})
    this.setState({ info: this.props.user }, () => {
      this.reloadTab()
    })
  }
  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      //console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          //console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }

  getMemberProfile = () => {
    whttp.get(API_HOST + `/api/account/oca/getProfiles`, {}, (state, res) => {
      console.log('getProfiles', `/api/account/oca/getProfiles`, res)
      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (code !== 200) {
        Modal.error({
          title: '資料讀取失敗',
          content: reason,
        })

        console.log('資料讀取失敗： ', reason)

        return this.setState({ messages: data.messages || {} })
      }
      console.log('getProfiles', data)
      this.setState({
        memberVip: data.member_profile_isvip == 0 ? '一般會員' : 'VIP',

        memberLinkcode: data.member_profile_linkcode,
        bonusPoint: parseInt(data.member_account_value, 10),
        bonusPointDiscount: parseInt(data.member_account_value / 300, 10),
      })
    })
  }

  LoadOCA = (info = {}) => {
    this.setState({ isSubmitData: true, messages: {} })

    whttp.get(
      API_HOST + `/api/account/oca/ocaUri?type=changepwd`,
      {},
      (state, res) => {
        //console.log(state, res, info)
        this.setState({ isSubmitData: false })

        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return message.error('發生錯誤')
        }

        if (code !== 200) {
          notification['error']({
            message: '資料讀取失敗',
            description: reason,
          })

          return this.setState({ messages: data.messages || {} })
        }
        //console.log(data)
        this.setState({ ocaUrl: data.uri })
      }
    )
  }
  getProfile = () => {
    this.setState({ isSubmitData: true, messages: {} })

    whttp.get(API_HOST + `/api/account/oca/getProfile`, {}, (state, res) => {
      this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (state === false) {
        return message.error('發生錯誤')
      }

      if (code !== 200) {
        notification['error']({
          message: '資料讀取失敗',
          description: reason,
        })

        return this.setState({ messages: data.messages || {} })
      }
      this.setState({ info: data })
      //console.log('getProfile',data)
    })
  }

  getIframeHeight = () => {
    var f = document.getElementById('iframe-pwd')
    f.style.height = f.contentWindow.document.body.scrollHeight + 40 + 'px'
  }

  render() {
    //const info  = this.state.info
    const ocaUrl = this.state.ocaUrl
    const ProfileInfo = _.get(this, 'state.info')
    const MemberVip = this.state.memberVip
    const MemberLinkcode = this.state.memberLinkcode
    const BonusPoint = this.state.bonusPoint
    const BonusPointDiscount = this.state.bonusPointDiscount
    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('更改密碼', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}
                <b className='fw-700'>{ProfileInfo && ProfileInfo.name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
              <div class='row no-gutters mx-n3 mb-4'>
                <div class='col-lg-4 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <div
                        class='hkcardontop'
                        style={{ textAlign: 'center' }}>
                        {MemberVip == 'VIP' ? (
                          <img
                            style={{ maxWidth: '180px' }}
                            className='img-contain'
                            src={`${
                              VC_CONFIG.INDEX_URL
                            }/wp-content/themes/cec/assets/img/membercard/2021VIPcard.png`}
                            alt=''
                          />
                        ) : (
                          <img
                            style={{ maxWidth: '180px' }}
                            className='img-contain'
                            src={`${
                              VC_CONFIG.INDEX_URL
                            }/wp-content/themes/cec/assets/img/membercard/newHKcard.png`}
                            alt=''
                          />
                        )}
                      </div>
                      {/*<h5 class="h3 text-navy text-center pt-3">好康卡</h5>*/}
                    </div>
                  </div>
                </div>
                <div class='col-lg-8 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body'>
                      <ul class='h6 text-navy text-justify list-unstyled'>
                        <li class='pb-1'>會員等級：{MemberVip}</li>
                        {/* <li class='pb-1'>會員卡號：{MemberLinkcode}</li> */}
                        <li class='pb-1'>好康點數：{BonusPoint}點</li>
                        <li class='pb-1'>
                          可兌換金額：{BonusPointDiscount}元
                        </li>
                      </ul>
                      <p class='h6 pt-4 text-font text-justify'>
                        *顯示之點數視消費情況更新！如遇資料交換造成點數延遲異動，以電腦系統為準。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className='mb-5 basic-tabs-label'>
            {Local == 'zh_TW' && (
              <ul className='nav nav-pills' id='pills-tab'>
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/profile`}>
                    {__('我的帳戶', 'cec-plugin-stores')}
                  </a>
                </li>
                <li className='nav-item  current_page_item highlight'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/pwd`}>
                    {__('更改密碼', 'cec-plugin-stores')}
                  </a>
                </li>
                {/* <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/payment`}
                  >
                    {__('我的消費紀錄', 'cec-plugin-stores')}
                  </a>
                </li> */}
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${
                      VC_CONFIG.INDEX_URL
                    }/einvoice-carrier-consolidation${
                      Local == 'en_US' ? '-en' : ''
                    }`}>
                    {__('發票歸戶', 'cec-plugin-stores')}
                  </a>
                </li>
              </ul>
            )}
            {Local == 'en_US' && (
              <ul className='nav nav-pills' id='pills-tab'>
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                    {__('我的帳戶', 'cec-plugin-stores')}
                  </a>
                </li>
                <li className='nav-item  current_page_item highlight'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/pwd-en`}>
                    {__('更改密碼', 'cec-plugin-stores')}
                  </a>
                </li>
                {/* <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/payment-en`}
                  >
                    {__('我的消費紀錄', 'cec-plugin-stores')}
                  </a>
                </li> */}
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href={`${
                      VC_CONFIG.INDEX_URL
                    }/einvoice-carrier-consolidation${
                      Local == 'en_US' ? '-en' : ''
                    }`}>
                    {__('發票歸戶', 'cec-plugin-stores')}
                  </a>
                </li>
              </ul>
            )}
          </div>
          <div align='center'>
            {ocaUrl && (
              <iframe
                id='iframe-pwd'
                title='iframe-pwd'
                //src="https://ppr-online.uni-prosperity.com.tw/testaccount/member/profile?client_id=c4fhcruwmgh6vz7n0l&amp;nonce_str=%21QAZxdr5×tamp=1595570823&amp;sign=7f9868830fe95472bc4e0d8bc37e926c5bba1b8272fdde1911bb78b60ba7f2c8&amp;access_token=9c1956af-9451-422d-8845-b63393b91776&amp;redirect_uri=https%3A%2F%2Fcec.syscom.tw%2Fservice%2Fsso%2F&amp;lang=zh_TW"
                src={ocaUrl}
                width='75%'
                height='600'
                scrolling='no'
                frameborder='no'
                onload={() => this.getIframeHeight()}
              />
            )}
          </div>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserPasswordOcaEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    //console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    //console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-catalogue-list-editor'>
        <h2>OCA更改密碼</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-password-oca.js